import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './navbar.css';
import { Link } from "@mui/material";
import { useNavigate } from 'react-router-dom';
function Navbar(){

  const navigate  = useNavigate();

  let home =()=>{
    navigate("/")
  }

  let login=()=>{
    navigate("/login")
  }

 




    return (
        <>
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark position-sticky">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">Hotel Management App</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a onClick={home} class="nav-link active" aria-current="page" href="#">Home</a>
        </li>
        
       
        {/* <li class="nav-item">
          <a class="nav-link disabled">Disabled</a>
        </li> */}
      </ul>
      <form class="d-flex">
        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
        <button  class="btn btn-secondary" className="searchButton" type="submit">Search</button>
      </form>

      <form class="d-flex">
        <Link to="/login">

        <button onClick={login} class="btn btn-primary m-2" type="submit">Login</button>
        </Link>
      </form>
    </div>
  </div>

  
</nav>
   <div>
    
    </div>     
        
        </>
    )
}

export default Navbar;